module.exports = __webpack_public_path__ + "img/paypal.349d208d.jpg";